var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8251 18.9584H5.17508C2.89175 18.9584 1.04175 17.1001 1.04175 14.8167V8.64173C1.04175 7.50839 1.74175 6.08339 2.64175 5.38339L7.13342 1.88339C8.48342 0.833393 10.6417 0.783393 12.0417 1.76673L17.1917 5.37506C18.1834 6.06673 18.9584 7.55006 18.9584 8.75839V14.8251C18.9584 17.1001 17.1084 18.9584 14.8251 18.9584ZM7.90008 2.86673L3.40841 6.36673C2.81675 6.83339 2.29175 7.89173 2.29175 8.64173V14.8167C2.29175 16.4084 3.58341 17.7084 5.17508 17.7084H14.8251C16.4167 17.7084 17.7084 16.4167 17.7084 14.8251V8.75839C17.7084 7.95839 17.1334 6.85006 16.4751 6.40006L11.3251 2.79173C10.3751 2.12506 8.80841 2.15839 7.90008 2.86673Z",
    fill: "#0A2341"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.625C9.65833 15.625 9.375 15.3417 9.375 15V12.5C9.375 12.1583 9.65833 11.875 10 11.875C10.3417 11.875 10.625 12.1583 10.625 12.5V15C10.625 15.3417 10.3417 15.625 10 15.625Z",
    fill: "#0A2341"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.60f092ca4d7eae764be89337c59767a9.svg";
export { ForwardRef as ReactComponent };